import { Swords } from "lucide-react";

/**
 * ActiveSetsBadge (iter67.2) — shows which item sets are currently active
 * (all required pieces equipped). Lives in the sidebar near StatsHUD.
 */
const SET_META = {
  gatekeepers_pact: {
    name: "Gatekeeper's Pact",
    desc: "+10% DMG vs BOSSES",
  },
  shadow_hunter: {
    name: "Shadow Hunter",
    desc: "+15% CRIT CHANCE",
  },
  archivists_vow: {
    name: "Archivist's Vow",
    desc: "HEAL +5 ON CRIT",
  },
};

export default function ActiveSetsBadge({ activeSets = [] }) {
  if (!activeSets || activeSets.length === 0) return null;
  return (
    <div className="panel p-3" data-testid="active-sets-badge">
      <div className="text-[10px] tracking-[0.3em] ash-text mb-2">— SET BONUS —</div>
      <div className="flex flex-col gap-2">
        {activeSets.map((key) => {
          const m = SET_META[key];
          if (!m) return null;
          return (
            <div
              key={key}
              className="flex flex-col gap-0.5"
              data-testid={`set-badge-${key}`}
              style={{ color: "#ffcd4a" }}
            >
              <div className="flex items-center gap-2 text-[11px]">
                <Swords size={14} />
                <span className="font-heading tracking-wider">{m.name.toUpperCase()}</span>
              </div>
              <span className="text-[10px] ash-text italic ml-[22px]">{m.desc}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
